import Skeleton from '@/common/components/skeleton/Skeleton';
import { HOME_PERSON_GRID_SKELETON_COUNT } from '../utils/homePersonGrid.constants';
import {
	HomePersonGridLayout,
	PersonCardSkeleton,
	PersonCardSkeletonInfo,
} from '../homePersonGrid.styles';

const HomePersonGridSkeleton = () => (
	<HomePersonGridLayout>
		{Array.from({ length: HOME_PERSON_GRID_SKELETON_COUNT }).map((_, index) => (
			<PersonCardSkeleton key={index} aria-hidden="true">
				<Skeleton
					width="100%"
					height="100%"
					radius="0"
					minWidth="100%"
					minHeight="100%"
				/>
				<PersonCardSkeletonInfo>
					<Skeleton width="58%" height="22px" radius="8px" minHeight="22px" />
					<Skeleton width="84%" height="14px" radius="6px" minHeight="14px" />
					<Skeleton width="72%" height="14px" radius="6px" minHeight="14px" />
				</PersonCardSkeletonInfo>
			</PersonCardSkeleton>
		))}
	</HomePersonGridLayout>
);

export default HomePersonGridSkeleton;
